import { ArrowRight, Building2, GraduationCap, MapPinned, PackageCheck, Sparkles, Target } from 'lucide-react';
import { trackEvent } from '../lib/analytics';

const funnelRoutes = [
  {
    icon: Sparkles,
    label: 'Ik begin net',
    title: 'Starterset zonder keuzestress',
    copy: 'Kies op aantal spelers, speelplek en of je al een net hebt.',
    href: '/pickleball-starterset-kopen/',
    cta: 'Vind starterset'
  },
  {
    icon: Target,
    label: 'Ik wil beter spelen',
    title: 'Paddle op controle, power en grip',
    copy: 'Voorkom een te dure of te snelle paddle als je vooral controle nodig hebt.',
    href: '/pickleball-paddle-kopen/',
    cta: 'Kies paddle'
  },
  {
    icon: PackageCheck,
    label: 'Ik regel materiaal',
    title: 'Ballen, netten en belijning per speelplek',
    copy: 'Scheid indoor, outdoor, sporthal en tijdelijk veld voordat je aantallen kiest.',
    href: '/pickleball-ballen-indoor-outdoor/',
    cta: 'Kies materiaal'
  },
  {
    icon: GraduationCap,
    label: 'School of gymles',
    title: 'Groepsmateriaal met veiligheidsroute',
    copy: 'Maak een pakket voor klasgrootte, haltype, opbouwtijd en toezicht.',
    href: '/pickleball-voor-scholen/',
    cta: 'Vraag schooladvies'
  },
  {
    icon: Building2,
    label: 'Club of vereniging',
    title: 'Clubpakket op offertebasis',
    copy: 'Combineer paddles, ballen, netten en grips voor clinics of vaste clubavond.',
    href: '/pickleball-clubpakket/',
    cta: 'Vraag clubofferte'
  },
  {
    icon: MapPinned,
    label: 'NL/BE route',
    title: 'Nederland, Vlaanderen en Brabant',
    copy: 'Bekijk service, levering en adviesroutes zonder voorraad- of winkelclaim.',
    href: '/pickleball-nederland/',
    cta: 'Bekijk regio'
  }
];

export function GrowthFunnelSection() {
  return (
    <section className="section growthFunnelSection" aria-labelledby="growth-funnel-heading">
      <div className="sectionHeading compactHeading">
        <p className="eyebrow">Kies je route</p>
        <h2 id="growth-funnel-heading">Niet iedereen zoekt hetzelfde pickleball product.</h2>
        <p className="sectionIntro">
          De snelste weg naar een goede keuze hangt af van wie speelt, waar je speelt en of je voor jezelf of een groep koopt.
        </p>
      </div>
      <div className="growthFunnelGrid">
        {funnelRoutes.map((route) => {
          const Icon = route.icon;
          return (
            <a
              className="growthFunnelCard"
              href={route.href}
              key={route.href}
              onClick={() => trackEvent({ event: 'cta_click', location: 'growth_funnel', label: route.label, routeFamily: 'home', placement: route.href })}
            >
              <span><Icon size={18} aria-hidden="true" /> {route.label}</span>
              <strong>{route.title}</strong>
              <p>{route.copy}</p>
              <small>{route.cta} <ArrowRight size={15} aria-hidden="true" /></small>
            </a>
          );
        })}
      </div>
    </section>
  );
}
